
export class ModalData {
    instance: any;
    component: any;
    disableClose: boolean;
}
